/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ time: NonNullable<unknown> }} Assistant_Activity_SeekInputs */



/**
* | output |
* | --- |
* | "Moved the player to {time}" |
*
* @param {Assistant_Activity_SeekInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const assistant_activity_seek = /** @type {((inputs: Assistant_Activity_SeekInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Assistant_Activity_SeekInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Le joueur a été déplacé vers ${i?.time}`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Der Spieler wurde nach ${i?.time} verschoben.`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Il giocatore è stato spostato in ${i?.time}`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Игрока переместили в ${i?.time}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`El jugador se movió a ${i?.time}`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`将玩家移至${i?.time}`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`プレイヤーを${i?.time}に移動しました`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`खिलाड़ी को ${i?.time} पर ले जाया गया`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`O jogador foi movido para ${i?.time}`)
	return /** @type {LocalizedString} */ (`Moved the player to ${i?.time}`)
});